import React, { useState } from "react";

function Pricing() {
  const [visibleAnswer, setVisibleAnswer] = useState(null);

  const toggleAnswer = (index) => {
    setVisibleAnswer(visibleAnswer === index ? null : index);
  };

  return (
    <div style={styles.container}>
      <div style={{ backgroundColor: "#f9f9f9", padding: "30px" }}>
        <h2 style={styles.heading}>Resume Templates for 2 USD Offer</h2>
        <p class="pricing-txt">
           Download your resume as many times as you want with a single click.
        </p>

        <div class="card-sec">
          <div class="pricing-sec">
           <ul style={styles.features}>
              <li style={styles.featureItem}>
                🎨 Access Premium Resume Templates
              </li>
              <li style={styles.featureItem}>
                📄 Export Unlimited PDFs– Download your resume anytime without watermarks or restrictions.
              </li>
              <li style={styles.featureItem}>
                💳 One-time Payment– Pay once, No recurring fees.
              </li>
              <li style={styles.featureItem}>
                ✨ Live Preview & Real-Time Editing – See your changes instantly with ease.
              </li>
            </ul>
          </div>

          <div class="pricing-img">
            <img
              src="https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator2.png"
              alt="Resume templates"          
            />
          </div>
        </div>
      </div>

      <div style={styles.faqSection}>
        <h4 style={styles.faqHeading}>📌 Frequently Asked Questions</h4>

        <div onClick={() => toggleAnswer(1)} style={styles.faqItem}>
          <strong>
            Is this a subscription? {visibleAnswer === 1 ? "–" : "+"}
          </strong>
          {visibleAnswer === 1 && (
            <p style={styles.answer}>
              No, it's a one-time payment.
            </p>
          )}
        </div>

        <div onClick={() => toggleAnswer(2)} style={styles.faqItem}>
          <strong>
            Can I make unlimited downloads? {visibleAnswer === 2 ? "–" : "+"}
          </strong>
          {visibleAnswer === 2 && (
            <p style={styles.answer}>
              Absolutely! You can download as many times as you like.
            </p>
          )}
        </div>

        <div onClick={() => toggleAnswer(3)} style={styles.faqItem}>
          <strong>
            What do I get after payment? {visibleAnswer === 3 ? "–" : "+"}
          </strong>
          {visibleAnswer === 3 && (
            <p style={styles.answer}>
              After placing your order, your resume can be downloaded form Account Dashboard.
            </p>
          )}
        </div>

        <div onClick={() => toggleAnswer(4)} style={styles.faqItem}>
          <strong>
            Can I edit my resume after placing the order? {visibleAnswer === 4 ? "–" : "+"}
          </strong>
          {visibleAnswer === 4 && (
            <p style={styles.answer}>
              No, once your order is placed, your resume cannot be edited. However, you can still download it as many times as you want from your <strong>Account Dashboard</strong>.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  },
  heading: {
    fontSize: "30px",
    marginBottom: "10px",
    fontWeight: "bold",
    color: "#222",
  },
  planTitle: {
    fontSize: "24px",
    marginBottom: "10px",
    textAlign: "center",
  },
  price: {
    fontSize: "26px",
    color: "#1a73e8",
    marginBottom: "20px",
    textAlign: "center",
    fontWeight: "bold",
  },
  features: {
    listStyle: "none",
    padding: 0,
    marginBottom: "20px",
  },
  featureItem: {
    marginBottom: "10px",
    fontSize: "15px",
    display: "flex",
    alignItems: "center",
  },
  faqSection: {
    marginTop: "40px",
    marginInline: "auto",
    textAlign: "center",
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
  },
  faqHeading: {
    fontSize: "18px",
    marginBottom: 30,
    fontWeight: "bold",
    color: "#333",
  },
  faqItem: {
    cursor: "pointer",
    marginBottom: "15px",
    fontSize: "15px",
    lineHeight: "1.5",
    color: "#333",
    border: "1px solid #ddd",
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "#fafafa",
    transition: "background-color 0.2s",
    textAlign: "left",
  },
  answer: {
    backgroundColor: "#ffffff",
    padding: "10px",
    borderRadius: "5px",
    marginTop: "15px",
    textAlign: "left",
  },
};

export default Pricing;
